export default __webpack_public_path__ + "static/imgTen-a2872b1cf0650fff9dda5b0b19cb9e24.jpg";